import React, { createContext, useReducer, useContext } from 'react';
import PropTypes from 'prop-types';
import { initialStates, actions } from './action';
import { debugLog } from './util';

const StoreContext = createContext(initialStates);

const reducer = (state, action) => {
  const act = actions[action.type];
  const update = act(state, action.payload);
  debugLog(`STORE: ${action.type}(${JSON.stringify(action.payload)})`);

  return { ...state, ...update };
};

export const StoreProvider = ({ children }) => {
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const [state, dispatch] = useReducer(reducer, initialStates);

  return (
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      <StoreContext.Provider value={{ state, dispatch }}>
          {children}
      </StoreContext.Provider>
    );
};

StoreProvider.propTypes = {
  children: PropTypes.node
};

export const useStore = () => {
  const { state, dispatch } = useContext(StoreContext);

  return { state, dispatch };
};
